import { useQuery, useReactiveVar } from '@apollo/client/react'

import { LOCATION, PARTNER } from './Header/locationQuery'

export function useLocation(store) {
  const { locationId, partnerId } = useReactiveVar(store)
  const { data, loading, error } = useQuery(LOCATION, {
    variables: { id: locationId },
    skip: !locationId,
  })
  const {
    data: partnerData,
    loading: partnerLoading,
    error: partnerError,
  } = useQuery(PARTNER, {
    variables: { partnerId },
    skip: !partnerId,
  })

  const location = data?.location ?? null
  const practice = location?.practice ?? null
  const patientFormConfig = practice?.bookingFormConfig ?? null
  const insuranceRequired =
    patientFormConfig?.isPatientInsuranceInfoRequired ?? false
  const commentRequired =
    patientFormConfig?.isPatientCommentRequired ?? false
  const practiceShowCareCreditPromo =
    patientFormConfig?.showCareCreditPromo ?? false
  const partnerDisablesCareCreditAds =
    partnerData?.partner?.disableCareCreditAds === true
  const showCareCreditPromo = partnerId
    ? !partnerLoading &&
      !partnerError &&
      practiceShowCareCreditPromo &&
      !partnerDisablesCareCreditAds
    : practiceShowCareCreditPromo
  const customTermsAddendum =
    patientFormConfig?.customTermsAddendum ?? null
  const patientSexOptions = practice?.patientSexOptions ?? []
  const isPatientSexRequired = practice?.isPatientSexRequired ?? false

  return {
    insuranceRequired,
    commentRequired,
    showCareCreditPromo,
    customTermsAddendum,
    patientSexOptions,
    isPatientSexRequired,
    loading,
    error,
  }
}